import React, { useEffect, useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { InputText } from 'primereact/inputtext';
import Button from '../../../../components/atoms/Button/Button';
import ButtonGris from '../../../../components/atoms/ButtonGris/ButtonGris';
import InputTextMy from '../../../../components/atoms/InputText/InputText';
import InputLista from '../../../../components/atoms/InputLista/InputLista';
import InputCalendario from '../../../../components/atoms/InputCalendario/InputCalendario';
import TextArea from '../../../../components/atoms/TextArea/TextArea';
import { addIncidente, getUsuariosIncidente, getIncidentesInternas } from '../CierreDeTurnoIntegracion';
import { formateoBasico } from '../../../../utilities/formateos';
import useGetDataUser from '../../../../CustomHooks/useGetDataUser';
import Swal from 'sweetalert2';

const FORM_VACIO = { bitacora: '', id_usuario_incidente: null, nota: '' };

const ModalAgregarInciente = ({ modoDetalle = 'nuevo' }) => {
    const userData = useGetDataUser();
    const getFechaTurno = () => {
        const d = new Date();
        d.setDate(d.getDate() - (d.getHours() >= 10 ? 1 : 2));
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };
    const sumarDias = (fecha, dias) => {
        const d = new Date(`${fecha}T00:00:00`);
        d.setDate(d.getDate() + dias);
        const yyyy = d.getFullYear();
        const mm = String(d.getMonth() + 1).padStart(2, '0');
        const dd = String(d.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };
    /* â”€â”€ Estado  */
    const hoy = formateoBasico(new Date());
    const ayer = (() => { const d = new Date(); d.setDate(d.getDate() - 1); return formateoBasico(d); })();

    const [fechaInicio, setFechaInicio] = useState(ayer);
    const [fechaFin, setFechaFin] = useState(hoy);
    const [incidencias, setIncidencias] = useState([]);
    const [loadingTabla, setLoadingTabla] = useState(false);
    const [globalFilter, setGlobalFilter] = useState('');

    const [formVisible, setFormVisible] = useState(false);
    const [modoForm, setModoForm] = useState('nuevo'); // 'nuevo' | 'ver'
    const [form, setForm] = useState(FORM_VACIO);
    const [registroVer, setRegistroVer] = useState(null);
    const [guardando, setGuardando] = useState(false);
    const enviando = useRef(false);

    const [usuariosIncidente, setUsuariosIncidente] = useState([]);

    useEffect(() => {
        getUsuariosIncidente().then((res) => setUsuariosIncidente(res ?? []));
    }, []);

    useEffect(() => {
        cargarTabla();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const fechaTurnoSiguiente = sumarDias(getFechaTurno(), 1);

    const cargarTabla = () => {
        setLoadingTabla(true);
        getIncidentesInternas(`${getFechaTurno()} 10:00:00`, `${fechaTurnoSiguiente} 23:59:59`)
            .then((res) => setIncidencias(res ?? []))
            .finally(() => setLoadingTabla(false));
    };

    const abrirNuevo = () => {
        setForm(FORM_VACIO);
        setModoForm('nuevo');
        setFormVisible(true);
    };

    const abrirVer = (row) => {
        setRegistroVer(row);
        setModoForm('ver');
        setFormVisible(true);
    };

    const cerrarFormulario = () => {
        setFormVisible(false);
        setForm(FORM_VACIO);
        setRegistroVer(null);
    };

    const handleGuardar = async () => {
        if (!form.id_usuario_incidente || enviando.current) return;
        enviando.current = true;
        setGuardando(true);
        try {
            const res = await addIncidente(form, userData?.ID);
            if (res?.status === 404) {
                Swal.fire({ icon: 'error', title: 'Error', text: res.message });
            } else {
                Swal.fire({ icon: 'success', title: 'Incidencia registrada' });
                cerrarFormulario();
                cargarTabla();
            }
        } catch {
            Swal.fire({ icon: 'error', title: 'Error', text: 'No se pudo guardar la incidencia.' });
        } finally {
            enviando.current = false;
            setGuardando(false);
        }
    };

    /* ── Columna acciones ──────────────────────────────────────────────────────────── */
    const accionesTpl = (row) => (
        <ButtonGris onClick={() => abrirVer(row)} width="70px">Ver</ButtonGris>
    );

    /* ── Encabezado inline ──────────────────────────────────────────────────────────── */
    const encabezado = () => (
        <div className="incidenciasInternas__header">
            <div className="incidenciasInternas__headerLeft">
                <i className="pi pi-flag" style={{ color: '#6366f1', fontSize: '1rem' }} />
                <span className="incidenciasInternas__titulo">Incidencias Internas</span>
                <span className="incidenciasInternas__badge">{incidencias.length}</span>
            </div>
            <div className="incidenciasInternas__headerRight">
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText
                        value={globalFilter}
                        onChange={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Buscar..."
                        className="buscadorModal"
                    />
                </IconField>
                {modoDetalle === 'nuevo' && (
                    <Button onClick={abrirNuevo} width="auto">
                        <i className="pi pi-plus" style={{ marginRight: '6px', fontSize: '0.75rem' }} />
                        Agregar incidencia
                    </Button>
                )}
            </div>
        </div>
    );

    /* ── Sección inline ──────────────────────────────────────────────────────────── */
    return (
        <>
            <div className="incidenciasInternas">
                {encabezado()}
                <DataTable
                    value={incidencias}
                    loading={loadingTabla}
                    globalFilter={globalFilter}
                    emptyMessage="Sin incidencias"
                    size="small"
                    stripedRows
                    scrollable
                    scrollHeight="40vh"
                    virtualScrollerOptions={{ itemSize: 36 }}
                    className="dashDataTable"
                >
                    <Column field="ID" header="Id" sortable />
                    <Column field="ID_BITACORA" header="Bitácora" sortable />
                    <Column field="FECHA" header="Fecha" sortable />
                    <Column field="REGISTRADO_POR" header="Registrado por" sortable />
                    <Column field="APLICADO_A" header="Aplicado a" sortable />
                    <Column
                        header=""
                        body={accionesTpl}
                        style={{ width: '80px', textAlign: 'center' }}
                        frozen
                        alignFrozen="right"
                    />
                </DataTable>
            </div>

            {/* ── Modal formulario (Nuevo / Ver) ────────────────────────────────────────────── */}
            <Dialog
                visible={formVisible}
                onHide={cerrarFormulario}
                header={modoForm === 'nuevo' ? 'Agregar Incidencia' : 'Detalle de Incidencia'}
                className="modalDashboard"
                style={{ width: '520px' }}
                modal
            >
                <div className="formIncidencia">
                    {/* ── Modo VER: campos de solo lectura ────────────────────────────────────────────── */}
                    {modoForm === 'ver' && (
                        <>
                            <InputTextMy
                                title="Bitácora"
                                value={registroVer?.ID_BITACORA ?? ''}
                                disabled
                                obligatorio={false}
                                className="formIncidencia__campo"
                            />
                            <InputTextMy
                                title="Fecha"
                                value={registroVer?.FECHA ?? ''}
                                disabled
                                obligatorio={false}
                                className="formIncidencia__campo"
                            />
                            <InputTextMy
                                title="Registrado por"
                                value={registroVer?.REGISTRADO_POR ?? ''}
                                disabled
                                obligatorio={false}
                                className="formIncidencia__campo"
                            />
                            <InputTextMy
                                title="Aplicado a"
                                value={registroVer?.APLICADO_A ?? ''}
                                disabled
                                obligatorio={false}
                                className="formIncidencia__campo"
                            />
                            <div className="formIncidencia__campofull">
                                <TextArea
                                    titulo="Nota"
                                    value={registroVer?.NOTA ?? ''}
                                    disabled
                                    obligatorio={false}
                                />
                            </div>
                            <div className="formIncidencia__acciones">
                                <ButtonGris onClick={cerrarFormulario} width="fit-content">
                                    Cerrar
                                </ButtonGris>
                            </div>
                        </>
                    )}

                    {modoForm === 'nuevo' && (
                        <>

                            <InputTextMy
                                title="Bitácora"
                                value={form.bitacora}
                                onChange={(e) => setForm((f) => ({ ...f, bitacora: e.target.value }))}
                                placeholder="ID de bitácora"
                                type="number"
                                className="formIncidencia__campo"
                            />
                            <InputLista
                                titulo="Aplicar incidente a"
                                value={form.id_usuario_incidente}
                                onChange={(e) => setForm((f) => ({ ...f, id_usuario_incidente: e.value }))}
                                options={usuariosIncidente}
                                placeholder="Seleccione un usuario..."
                                obligatory
                                className="formIncidencia__campo"
                            />
                            <div className="formIncidencia__campofull">
                                <TextArea
                                    titulo="Nota"
                                    value={form.nota}
                                    onChange={(e) => setForm((f) => ({ ...f, nota: e.target.value }))}
                                    obligatorio={false}
                                    placeholder="Observaciones adicionales..."
                                />
                            </div>
                            <div className="formIncidencia__acciones">
                                <Button
                                    onClick={handleGuardar}
                                    width="fit-content"
                                    disabled={guardando || !form.id_usuario_incidente}
                                >
                                    {guardando ? 'Guardando...' : 'Guardar'}
                                </Button>
                                <ButtonGris onClick={cerrarFormulario} width="fit-content">
                                    Cancelar
                                </ButtonGris>
                            </div>
                        </>
                    )}
                </div>
            </Dialog>
        </>
    );
};

export default ModalAgregarInciente;
